import { render, staticRenderFns } from "./stereoscopicHistogram.vue?vue&type=template&id=8bced56c"
import script from "./stereoscopicHistogram.vue?vue&type=script&lang=js"
export * from "./stereoscopicHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports